import * as React from 'react'

import type { ShipmentPaymentFeedItem } from '#/entities/shipment'
import { PaymentIcon } from '#/shared/ui/icons'
import { HistoryRow } from '#/shared/ui/history-row'

function paymentMeta(item: ShipmentPaymentFeedItem): React.ReactNode[] {
  const meta: React.ReactNode[] = []
  if (item.timestamp) meta.push(item.timestamp)
  if (item.customerName) meta.push(item.customerName)
  if (item.status) meta.push(item.status)
  if (item.cardLast4) meta.push(`•••• ${item.cardLast4}`)
  return meta
}

export function PaymentHistoryRow({
  payment,
}: {
  payment: ShipmentPaymentFeedItem
}) {
  return (
    <HistoryRow
      icon={PaymentIcon}
      title={payment.amount}
      meta={paymentMeta(payment)}
    />
  )
}
